var SmoothScroll = function () {
  var init = function () {
    $('a[href^=\\/\\#], a[href^=\\#]').on('click', function (event) {
      event.preventDefault()
      if (this.hash) {
        $('html,body').animate({ scrollTop: $(this.hash).offset().top - 100 }, 500)
      }
    })

    $(document).ready(function () {
      if (location.hash) {
        $('html,body').animate({ scrollTop: $(location.hash).offset().top - 100 }, 500)
      }
    })
  }

  return {
    init: init
  }
}()

UL.register(SmoothScroll)
